import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AccountService } from 'app/guards/account.service';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    fuseConfig: any;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    userName: string;
    public picture: string;
    form: FormGroup;


    // Private
    private _unsubscribeAll: Subject<any>;
    public IsCheckedTheme = true;


    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _accountService:AccountService,
        private _router: Router,
        public appConfigService: AppInitializationService,
        private _formBuilder: FormBuilder
    ) {


        this.languages = [
            {
                id: 'tr',
                title: 'Türkçe',
                flag: 'tr2'
            },
            {
                id: 'en',
                title: 'English',
                flag: 'us'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }


    async ngOnInit(): Promise<void> {
        this.selectedLanguage = _.find(this.languages, { id: this._translateService.currentLang })
        
        try {
            this.userName = localStorage.getItem("Username");
            this.picture = localStorage.getItem("UserImage")

        } catch (error) {
            console.warn(error);

        }

        
        this.form = this._formBuilder.group({
            colorTheme: new FormControl(),
            layout: this._formBuilder.group({
                style: new FormControl()
            })
        });

        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                // Update the stored config
                this.fuseConfig = config;

                // Set the config form values without emitting an event
                // so that we don't end up with an infinite loop
                this.form.setValue(config, { emitEvent: false });
            });


        // Subscribe to the form value changes
        this.form.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                // Update the config
                this._fuseConfigService.config = config;
            });
        this.onThemeChecked(false);
        // Set the selected language from default languages
    }


    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }
    onThemeChecked(e) {
        this.form.controls['colorTheme'].setValue(e ? 'theme-default' : 'theme-blue-gray-dark');
    }




    setLanguage(lang): void {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;
        this._translateService.use(lang.id);        
    }

    public logout() {
        this._accountService.logout();
        this._router.navigate(['auth/login']);
    }
}
